import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { roleRoutes } from "../config/roles";
import { hasSubscriptionFeature } from "../config/subscriptionConfig";


export default function ProtectedRoute({
  children,
  allowedRoles,
  requiredFeature,
  requiredPermission,
  requiredAnyPermission,
}) {
  const { currentUser } = useSelector((state) => state.user);
  const { currentSchool } = useSelector((state) => state.school);
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(currentUser.role)) {
    const path = roleRoutes[currentUser.role] || "/";
    return <Navigate to={path} replace />;
  }

  if (
    requiredFeature &&
    !hasSubscriptionFeature(
      currentSchool?.subscription?.featureTier,
      requiredFeature,
    )
  ) {
    return <Navigate to={roleRoutes[currentUser.role] || "/"} replace />;
  }

  if (
    (requiredPermission || requiredAnyPermission) &&
    currentUser.role !== "admin" &&
    currentUser.role !== "appOwner" &&
    ![requiredPermission, requiredAnyPermission]
      .flat()
      .filter(Boolean)
      .some((permission) => currentUser.permissions?.[permission])
  ) {
    return <Navigate to={roleRoutes[currentUser.role] || "/"} replace />;
  }

  return children;
}

// Protected Route Component
// function ProtectedRoute({ isAuthenticated }) {
//   return isAuthenticated ? <Outlet /> : <Navigate to="/signin" replace />;
// }
